export default {
  logoHeader: require('./media/logos/HeaderLogo.png'),
  iconLogin: require('./media/images/login-image.png'),
  iconChangeDroner: require('./media/images/iconChangDrone.png'),
  iconChangeTime: require('./media/images/changeTime.png'),
  iconReviewDroner: require('./media/images/reviewDroner.png'),
  iconExtend: require('./media/images/extend.png'),
  iconTime: require('./media/images/time.png'),
  pointActive: require('./media/images/pointactive.png'),
  pointDrafting: require('./media/images/pointdrafting.png'),
  pointDisabled: require('./media/images/pointdisabled.png'),
  pointWarning: require('./media/images/pointwarning.png'),
  adminlogo: require('./media/images/adminlogo.png'),
  iconcopy: require('./media/images/copy.png'),
  icondelete: require('./media/images/delete.png'),
  injection: require('./media/images/injectionicon.png'),
  drug: require('./media/images/drugicon.png'),
  arrowUp: require('./media/images/arrowUp.png'),
  arrowDown: require('./media/images/arrowDown.png'),
  arrowGreen: require('./media/images/arraow-green.png'),
  inforedeem: require('./media/images/info-redeem.png'),
  coinFarmer: require('./media/images/coin.png'),
  coinDroner: require('./media/images/coinDroner.png'),
  iconQuotaReport: require('./media/images/icon-quota-report.png'),
  arrowReport: require('./media/images/arrowReport.png'),
  coin: require('./media/images/coin.png'),
  pointRankActive: require('./media/images/point-rank-active.png'),
  pointRankInActive: require('./media/images/point-rank-inactive.png'),
  targetActive: require('./media/images/target-active.png'),
  targetInActive: require('./media/images/target-inactive.png'),
  quotaReport: require('./media/images/quotaReport_inactive.png'),
  arrowDownWhite: require('./media/images/arrow_down_white.png'),
  pin: require('./media/images/pin.png'),
  task_active: require('./media/images/task_active.png'),
  task_inactive: require('./media/images/task_inactive.png'),
  news_active: require('./media/images/news_active.png'),
  news_inactive: require('./media/images/news_inactive.png'),
  farmer_active: require('./media/images/farmer_active.png'),
  farmer_inactive: require('./media/images/farmer_inactive.png'),
  droner_inactive: require('./media/images/droner_inactive.png'),
  droner_active: require('./media/images/droner_active.png'),
  admin_inactive: require('./media/images/admin_inactive.png'),
  admin_active: require('./media/images/admin_active.png'),
  check: require('./media/images/check.png'),
  cancel: require('./media/images/cancel.png'),
  dronerApp: require('./media/images/dronerApp.png'),
  farmerApp: require('./media/images/farmerApp.png'),
  lineApp: require('./media/images/line.png'),
  bo: require('./media/images/bo.png'),
  folder_icon: require('./media/images/folder_icon.png'),
  icon_news_active: require('./media/images/icon_news_active.png'),
  icon_reward_active: require('./media/images/icon_reward_active.png'),
  icon_challenge_active: require('./media/images/icon_challenge_active.png'),
  icon_news: require('./media/images/icon_news.png'),
  icon_reward: require('./media/images/icon_reward.png'),
  icon_challenge: require('./media/images/icon_challenge.png'),
  returnPoint: require('./media/images/return_point.png'),
  arrowDownMenu: require('./media/images/arrowDownMenu.png'),
  arrowUpMenu: require('./media/images/arrowUpMenu.png'),
  arrowUpYellowMenu: require('./media/images/arrowUpMenuYellow.png'),
  comment: require('./media/images/comments.png'),
  love: require('./media/images/love.png'),
  view: require('./media/images/view.png'),
  typcn_video: require('./media/images/typcn_video.png'),
  iconkaset: require('./media/images/iconkaset.png'),
  love_bullet: require('./media/images/love-bullet.png'),
  comments_bullet: require('./media/images/comments-bullet.png'),
  play: require('./media/images/play.png'),
  pause: require('./media/images/pause.png'),
  fertilizer: require('./media/images/fertilizer.png'),
  account_cancel_disable: require('./media/images/account_cancel_disable.png'),
  account_cancel: require('./media/images/account_cancel.png'),
  wallet: require('./media/images/wallet.png'),
  credit: require('./media/images/credit.png'),
  nearequal: require('./media/images/nearequal.png'),
  upload_droner: require('./media/images/upload_droner.png'),
  icon_setting_inactive: require('./media/images/icon_setting_inactive.png'),
  icon_setting: require('./media/images/icon_setting.png'),
  icon_cart: require('./media/images/icon_cart.png'),
  info_redeem_inactive: require('./media/images/info-redeem-inactive.png'),

}
